import { TenantConfig } from "interfaces/common";
import React, { createContext, useContext, useState } from "react";

export interface TenantConfigContextType {
  tenantConfig: TenantConfig;
  setTenantConfig: (tenantConfig: TenantConfig) => void;
}

const TenantConfigContext = createContext<TenantConfigContextType | null>(null);

export const initialTenantConfig: TenantConfig = {
  immobilisation: "Immobilisation",
  showUrethrogram: false,
  showIsocenter: false,
  phaseLabel: "Phase",
  region: null,
  peerReview: false,
  showTestTemplateStatus: true,
};

export const TenantConfigProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [tenantConfig, setTenantConfig] =
    useState<TenantConfig>(initialTenantConfig);
  return (
    <TenantConfigContext.Provider value={{ tenantConfig, setTenantConfig }}>
      {children}
    </TenantConfigContext.Provider>
  );
};

export const useTenantConfig = () => {
  const context = useContext(TenantConfigContext);
  if (!context) {
    throw new Error(
      "useTenantConfig must be used within a TenantConfigProvider",
    );
  }
  return context;
};
